export default {
  xs: '0px',
  sm: '390px',
  md: '576px',
  lg: '1024px',
  xl: '1440px',
};
